export default {
    cptDataForm: {
        dataText: '{"value":15685,"growth":0.0125}', dataSource: 1, pollTime: 0
    },
    attribute: {
        icon:{
            url:'',
            padding:8
        },
        title:{
            fontSize:14,
            color:'#fff',
            fontFamily:'',
            text:'一季度GDP',
            fontWeight:'normal'
        },
        num:{
            fontSize:18,
            color:'#57b1ea',
            fontFamily:'lccd',
            unit:'万元',
            fontWeight:'normal'
        },
        grow:{
            show:true,
            label:'同比',
            fontSize:14,
            color:'#7ccc04',
            fontFamily:''
        },
        alarmConfig:{
            operator:'>',
            threshold:'',
            textColor:'#f00'
        },
        cptTableData:[{"name":"指标","value":"","namekey":"value"},{"name":"增长值","value":"","namekey":"growth"}]
    },
    interaction:{intType: 'none'}
}